<script lang="ts">
	import { goto } from '$app/navigation';
	import {
		currentMarket,
		markets,
		totalMarketOpenInterest,
		totalMarketTrades,
		totalMarketVolume
	} from '$lib/home/store';
	import { addDollarSign, getNumBackInUnits } from '$lib/util/util';

	$: totalMarkets = $markets?.length;
</script>

<div class="flex-col sm:grid sm:grid-cols-4 sm:gap-5 w-full mt-2">
	<div
		class="hidden sm:block border border-fx-grey-600 bg-fx-gradient-8-40 rounded-xl squircle-xl w-full px-4 sm:px-8 sm:py-4 py-2"
	>
		<div class="text-xs text-fx-grey-400">Total Traded Volume (in last 24 hr):</div>

		<div class="flex mt-2 gap-2 items-center">
			{#if $currentMarket}
				<div class="text-fx-grey-100 font-semibold sm:text-2xl text-lg">
					{addDollarSign(getNumBackInUnits($totalMarketVolume, 18, 2))}
				</div>
			{:else}
				<div class="h-8 w-40 bg-fx-grey-600 animate-pulse rounded-lg squircle-lg" />
			{/if}
		</div>
	</div>
	<div
		class="hidden sm:block border border-fx-grey-600 bg-fx-gradient-8-40 rounded-xl squircle-xl w-full px-4 sm:px-8 py-2 sm:py-4 my-2 sm:my-0"
	>
		<div class="text-xs text-fx-grey-400">Open Interest:</div>
		<div class="flex mt-2 gap-2 items-center">
			{#if $currentMarket}
				<div class="text-fx-grey-100 font-semibold sm:text-2xl text-lg">
					{addDollarSign(getNumBackInUnits($totalMarketOpenInterest, 18, 2), 3)}
				</div>
			{:else}
				<div class="h-8 w-40 bg-fx-grey-600 animate-pulse rounded-lg squircle-lg" />
			{/if}
		</div>
	</div>
	<div
		class="hidden sm:block border border-fx-grey-600 bg-fx-gradient-8-40 rounded-xl squircle-xl w-full px-4 sm:px-8 sm:py-4 py-2"
	>
		<div class="text-xs text-fx-grey-400">Trades (in last 24 hr):</div>

		<div class="flex mt-2 gap-2 items-center">
			{#if $currentMarket}
				<div class="text-fx-grey-100 font-semibold sm:text-2xl text-lg">
					{$totalMarketTrades}
				</div>
			{:else}
				<div class="h-8 w-40 bg-fx-grey-600 animate-pulse rounded-lg squircle-lg" />
			{/if}
		</div>
	</div>

	<button
		class="hidden sm:block border border-fx-grey-600 bg-fx-gradient-8-40 rounded-xl squircle-xl w-full px-4 sm:px-8 sm:py-4 py-2"
		on:click={() => goto('/markets')}
	>
		<div class="text-xs text-fx-grey-400 text-left">Active Markets:</div>

		<div class="flex mt-2 gap-2 items-center">
			<div class="text-fx-grey-100 font-semibold sm:text-2xl text-lg">
				{totalMarkets}
				<span class="text-fx-gradient-5 text-xs font-semibold cursor-pointer"> View All </span>
			</div>
		</div>
	</button>
</div>
